const StatisticalDept = () =>
  import('@/views/main/fubo/statisticalDept/StatisticalDept.vue')
export default {
  path: '/main/fubo/statisticalDept',
  name: 'FuboStatisticalDept',
  component: StatisticalDept,
  children: []
}
